import { useSelectionStore } from '@/state/selection';
import { stations, useTourStore } from '@/state/tour';
import { stationImpl } from '@/stations';
import { ElementCard } from './ElementCard';

export function StationPanel() {
  const activeIndex = useTourStore((s) => s.activeIndex);
  const selected = useSelectionStore((s) => s.selected);
  const Panel = stationImpl(stations[activeIndex]!.kind).Panel;
  if (!Panel && !selected) return null;
  return (
    <aside className="lens-dock" key={activeIndex}>
      <ElementCard />
      {Panel && <Panel />}
    </aside>
  );
}
